import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';


const routes = {
  filter: '/department/filter',
  createDepartment: '/department/create',
  updateDepartment: '/department/update',
  assignRepresentative: '/department/assign-representative',
  deleteDepartment: (id: any) => `/department/delete/${id}`,
  getUserDepartment: (id: any) => `/department/user-department/${id}`,
  updateUserInDepartment: '/department/update-user',
  getUserByFullNameOrEmail: (name: string) => `/department/find-user?filter=${name}`,
  lockDepartment: (id: any) => `/department/lock/${id}`,
  unLockDepartment: (id: any) => `/department/unlock/${id}`,
  getUsersByDepartment: '/department/filter-user',
  deleteUserInDepartment: '/department/delete-user',
  getAllDepartment: '/department/get-department',
  getDepartmentInactiveById: (id: any) => `/department/get-department-inactive/${id}`,
  getRepresentativeIdByDepartmentId: (id: any) => `/department/get-representative-by-department/${id}`,
  getDepartmentByUserEnterprise: (id: any) => `/department/get-department-user-enterprise/${id}`,
};

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(
    private apiService: ApiService,) {
  }

    createDepartment(dto: any) {
      return this.apiService.post(routes.createDepartment, dto).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    updateDepartment(dto: any) {
      return this.apiService.post(routes.updateDepartment, dto).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    deleteDepartment(id: any) {
      return this.apiService.get(routes.deleteDepartment(id)).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    getUserDepartment(id: any) {
      return this.apiService.get(routes.getUserDepartment(id)).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    updateUserInDepartment(dto: any) {
      return this.apiService.post(routes.updateUserInDepartment, dto).pipe(
        map(rs => {
          return rs;
        })
      );
    }
    searchDepartment(dto: any) {
      // console.log(dto);
      return this.apiService.post(routes.filter, dto).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    getUserByFullNameOrEmail(name: string) {
      return this.apiService.get(routes.getUserByFullNameOrEmail(name)).pipe(map(res => {
        return res;
      })); 
    }

    lockDepartment(id: any) {
      return this.apiService.get(routes.lockDepartment(id)).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    unLockDepartment(id: any) {
      return this.apiService.get(routes.unLockDepartment(id)).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    assignRepresentative(dto: any) {
      return this.apiService.post(routes.assignRepresentative, dto).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    getUsersByDepartment(dto: any){
      return this.apiService.post(routes.getUsersByDepartment, dto).pipe(
        map(rs => {
          return rs;
        })
      )
    }

    deleteUserInDepartment(dto: any) {
      return this.apiService.post(routes.deleteUserInDepartment, dto).pipe(
        map(rs => {
          return rs;
        })
      )
    }

    getAllDepartment() {
      return this.apiService.get(routes.getAllDepartment).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    getDepartmentInactiveById(departmentId: any) {
      return this.apiService.get(routes.getDepartmentInactiveById(departmentId)).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    getRepresentativeByDepartmentId(departmentId: any){
      return this.apiService.get(routes.getRepresentativeIdByDepartmentId(departmentId)).pipe(
        map(rs => {
          return rs;
        })
      );
    }

    getDepartmentByUserEnterprise(userEnterpriseId: any) {
      return this.apiService.get(routes.getDepartmentByUserEnterprise(userEnterpriseId)).pipe(
        map(rs => {
          return rs;
        })
      );
    }

}
